import { cx } from '@libs/classnames';

import styles from './PlayerPanelSkeleton.module.css';

export type PlayerPanelSkeletonProps = {
  orientation?: 'top' | 'bottom';
};

export function PlayerPanelSkeleton({ orientation = 'top' }: PlayerPanelSkeletonProps) {
  return (
    <section
      className={cx(styles.player_skeleton, {
        [styles.is_reverse]: orientation === 'bottom',
      })}
    >
      <div className={styles.block_large} />
      <div className={styles.block_small} />
    </section>
  );
}
